import React from 'react';
import { useLinkPresenter } from './Link.presenter';

import { VOID_FUNCTION } from 'constants/index';

import * as S from './Link.styles';

export const Link = (props) => {
  const {
    className,
    children,
    name = '',
    theme = '1',
    size = 'm',
    href = '',
    target = '_self', // _blank, _self, _parent, _top
    iconLeft = null,
    iconRight = null,
    fontWeight = 'large', // regular
    disabled = false,
    onClick = VOID_FUNCTION,
    dataTest = '',
  } = props;

  const presenter = useLinkPresenter({ href });

  const content = (
    <S.ContentWrapper>
      {iconLeft && <S.StyledIcon Icon={iconLeft} iconLeft size={presenter.getIconSize(size)} />}
      <S.Text>{children}</S.Text>
      {iconRight && <S.StyledIcon Icon={iconRight} iconRight size={presenter.getIconSize(size)} />}
    </S.ContentWrapper>
  );

  return (
    <S.Container className={className} name={name} theme={theme} size={size} disabled={disabled}>
      {presenter.hasHref && (
        <S.StyledLink
          href={!disabled ? href : undefined}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          fontWeight={fontWeight}
          isDisabled={disabled}
          data-test={`${dataTest}-singleLink`}
        >
          {content}
        </S.StyledLink>
      )}

      {presenter.isButton && (
        <S.StyledButton
          fontWeight={fontWeight}
          onClick={onClick}
          isDisabled={disabled}
          data-test={`${dataTest}-buttonLink`}
        >
          {content}
        </S.StyledButton>
      )}
    </S.Container>
  );
};
